import HttpService from "@core/services/http/http.service";
import {
  ForgotPasswordResponse,
  LoginResponse,
  SignUpRequest,
  SocialLoginRequest,
} from "@app/types";

class _AuthService {
  public login(email: string, password: string) {
    return HttpService.post<LoginResponse>("/user/api/v2/auth/login", {
      body: {
        email,
        password,
      },
    });
  }

  public signUp(signUpRequest: SignUpRequest) {
    return HttpService.post<LoginResponse>("/user/api/v2/auth/register", {
      body: { ...signUpRequest },
    });
  }

  public loginSocial(socialLoginRequest: SocialLoginRequest) {
    return HttpService.post<LoginResponse>("/user/api/v2/oauth/social-media", {
      body: { ...socialLoginRequest },
    });
  }

  public forgotPassword(username: string, isSendToPhone = false) {
    return HttpService.post<ForgotPasswordResponse>(
      "/user/api/v1/auth/forgot-password",
      {
        body: {
          username,
          isSendToPhone,
        },
      }
    );
  }

  public confirmChangePassword(otp: string, password: string) {
    return HttpService.post<ForgotPasswordResponse>(
      "/user/api/v1/auth/change-password-otp",
      {
        body: {
          otp,
          password,
        },
      }
    );
  }
}

const AuthService = new _AuthService();

export default AuthService;
